import { $$_create_walker, $$_effect, $$_attr, $$_listen, $$_scoped, $$_insert_at_marker_lite, $$_setup_custom_element, $$_create_template } from 'maverick.js/dom';

// src/player/ui/menu/radio/render.tsx
var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><media-radio-group mk-d><!$></media-radio-group>`);
var $$_templ_2 = /* @__PURE__ */ $$_create_template(`<!$><media-radio mk-d><!$></media-radio>`);
function renderRadioGroup(props) {
  const { value, onChange, radioGroupClass } = props;
  return (() => {
    const [$$_root, $$_walker] = $$_create_walker($$_templ), $$_expr = $$_walker.nextNode();
    $$_effect(() => $$_attr($$_root, "class", radioGroupClass()));
    $$_listen($$_root, "change", onChange);
    $$_scoped(() => {
      $$_insert_at_marker_lite($$_expr, () => renderOptions(props));
    }, $$_setup_custom_element($$_root, { value }));
    return $$_root;
  })();
}
function renderOptions(props) {
  const { options } = props;
  return options().map((option) => {
    return (() => {
      const [$$_root, $$_walker] = $$_create_walker($$_templ_2), $$_expr = $$_walker.nextNode();
      $$_attr($$_root, "part", props.part);
      $$_scoped(() => {
        $$_insert_at_marker_lite($$_expr, option.content);
      }, $$_setup_custom_element($$_root, { value: option.value }));
      return $$_root;
    })();
  });
}

export { renderRadioGroup };
